/**
 * У каких отрядов итог ближнего боя сейчас придержан: удары на поле еще идут,
 * и урон на плашке отряда не показан (см. HexGridRenderer.showMeleeAnimation).
 *
 * Знает об этом рендерер поля (Phaser), а нужно это и интерфейсу (React):
 * панель с расчетом урона в футере показывает те же числа и не должна
 * открываться раньше, чем отыграют удары (см. useMeleeResultRevealed).
 *
 * Анимаций может идти несколько разом (бой целиком и следом повтор ударов
 * одного отряда после выбора приоритетной цели): у каждой свой список отрядов,
 * отряд придержан, пока он есть хотя бы в одном.
 *
 * Отдельный маленький источник с подпиской, а не redux — как у выстрела (см.
 * shotFlightTracker): это состояние анимации, а не партии.
 */
const heldUnitIdsByAnimation = new Map();
const listeners = new Set();
// Когда итог боя последний раз открылся (Date.now); null — боя еще не было
let lastReleaseAt = null;

const notify = () => {
  // Копия: слушатель может отписаться прямо из своего вызова
  [...listeners].forEach((listener) => listener());
};

/** Удары пошли: итог боя этих отрядов придержан до конца анимации */
export const holdMeleeResult = (animationId, unitIds) => {
  if (!animationId) {
    return;
  }
  heldUnitIdsByAnimation.set(animationId, new Set(unitIds || []));
  notify();
};

/** Удары отыграли (или оборваны): итог боя виден */
export const releaseMeleeResult = (animationId) => {
  if (heldUnitIdsByAnimation.delete(animationId)) {
    lastReleaseAt = Date.now();
    notify();
  }
};

export const checkIfMeleeResultHeld = (unitId) => {
  if (!unitId) {
    return false;
  }
  for (const unitIds of heldUnitIdsByAnimation.values()) {
    if (unitIds.has(unitId)) {
      return true;
    }
  }
  return false;
};

/** Идут ли сейчас хоть какие-то удары (итог боя придержан хотя бы у одного отряда) */
export const checkIfAnyMeleeResultHeld = () => heldUnitIdsByAnimation.size > 0;

/**
 * Когда итог боя последний раз появился на поле (Date.now). Обучение ждет с
 * модалкой шага, пока итог не побудет на виду (см. tutorialMiddleware)
 * @returns {number|null}
 */
export const getLastMeleeResultReleaseAt = () => lastReleaseAt;

/**
 * Подписка на перемены: начало и конец анимации ударов
 * @returns {Function} отписка
 */
export const subscribeToMeleeResultHolds = (listener) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

/** Забыть все (тесты) */
export const resetMeleeResultHolds = () => {
  lastReleaseAt = null;
  if (heldUnitIdsByAnimation.size === 0) {
    return;
  }
  heldUnitIdsByAnimation.clear();
  notify();
};
